import { Link } from 'react-router-dom'

// Real ARPU handles provided by Lauren (2026-06-29). Instagram is "coming soon"
// and YouTube was not provided, so only Facebook + TikTok are shown for now.
// Newsletter signup hands off to pigeon.org, which owns the mailing list.
const SOCIAL = {
  facebook: 'https://www.facebook.com/AURACINGPIGEONS',
  tiktok: 'https://www.tiktok.com/@arpupigeon',
}

export function Footer() {
  const year = new Date().getFullYear()

  const handleSubscribe = (e: { preventDefault: () => void }) => {
    e.preventDefault()
    window.open('https://pigeon.org', '_blank', 'noopener,noreferrer')
  }

  return (
    <footer className="mt-auto bg-secondary font-body text-text">
      <div className="max-w-7xl mx-auto px-page py-10">
        <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-6">
          {/* Contact Us — deep-navy column (Wix reserves #001578 here) */}
          <div className="bg-primary-dark text-text-inverse p-8 rounded-sm">
            <h3 className="font-heading font-bold text-xl mb-4">Contact Us</h3>
            <p className="text-sm leading-7">
              P.O. Box 18465
              <br />
              Oklahoma City, OK 73154
            </p>
            <p className="text-sm mt-3">
              Tel:{' '}
              <a href="tel:405-848-5801" className="hover:underline">
                405-848-5801
              </a>
            </p>
            <p className="text-sm mt-3">
              <Link to="/contact" className="underline hover:no-underline">
                Send us a message
              </Link>
            </p>
          </div>

          {/* Gray panel — Info + Mailing list + Social */}
          <div className="bg-[var(--color-footer-panel)] p-8 rounded-sm grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Info / quick links */}
            <div>
              <h3 className="font-heading font-bold text-xl mb-3 text-text">Info</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/clubs" className="hover:text-secondary transition-colors">
                    Clubs
                  </Link>
                </li>
                <li>
                  <Link to="/find-club" className="hover:text-secondary transition-colors">
                    Find a Club
                  </Link>
                </li>
                <li>
                  <Link to="/join" className="hover:text-secondary transition-colors">
                    Join the AU
                  </Link>
                </li>
                <li>
                  <a
                    href="https://pigeon.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-secondary transition-colors"
                  >
                    Report Lost Pigeon
                  </a>
                </li>
                <li>
                  <a
                    href="https://pigeon.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-secondary transition-colors"
                  >
                    pigeon.org
                  </a>
                </li>
              </ul>
            </div>

            {/* Mailing list + social */}
            <div>
              <h3 className="font-heading font-bold text-xl mb-3 text-text">Join Our Mailing List</h3>
              <form onSubmit={handleSubscribe} className="space-y-2">
                <label htmlFor="footer-email" className="block text-sm text-text">
                  Email Address<span className="text-secondary">*</span>
                </label>
                <input
                  id="footer-email"
                  type="email"
                  required
                  className="w-full border border-white/70 bg-white px-3 py-2 text-sm text-text focus:outline-none focus:border-primary"
                />
                <button
                  type="submit"
                  className="w-full bg-primary hover:bg-primary-light text-text-inverse font-heading font-semibold py-2 rounded-sm transition-colors"
                >
                  Subscribe
                </button>
              </form>

              <h4 className="font-heading font-bold text-base mt-6 mb-3 text-text">
                Follow Us on Our Social Media
              </h4>
              <div className="flex items-center gap-4 text-text">
                <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-secondary transition-colors">
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22 12a10 10 0 1 0-11.5 9.9v-7H8v-2.9h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6v1.8h2.8L15.7 15h-2.3v7A10 10 0 0 0 22 12z" />
                  </svg>
                </a>
                <a href={SOCIAL.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-secondary transition-colors">
                  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16.5 3c.3 1.6 1.2 3 2.5 3.9.8.5 1.7.9 2.7 1v3.1a8.2 8.2 0 0 1-4.2-1.4v6.1a6 6 0 1 1-6-6c.3 0 .6 0 .9.06v3.15a2.9 2.9 0 1 0 2.1 2.79V3h2z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright strip */}
      <div className="border-t border-white/20 py-3 text-center text-text-inverse text-sm">
        &copy; {year} American Racing Pigeon Union
      </div>
    </footer>
  )
}
